import React from 'react';
import { Toast } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

const ErrorToast = ({ show, onClose, title = "Error", message, autoHide = true }) => {
  return (
    <div className="toast-container position-fixed top-0 end-0 p-3" style={{ zIndex: 9999 }}>
      <Toast 
        show={show} 
        onClose={onClose} 
        autohide={autoHide}
        delay={5000}
        className="error-toast"
      >
        <Toast.Header className="bg-danger text-white">
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
          <strong className="me-auto">{title}</strong>
        </Toast.Header>
        <Toast.Body>
          {message}
        </Toast.Body>
      </Toast>
    </div>
  );
};

export default ErrorToast;